import { render, staticRenderFns } from "./CorpModal.vue?vue&type=template&id=65d36353&"
import script from "./CorpModal.vue?vue&type=script&lang=ts&"
export * from "./CorpModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports